import React from 'react';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import CustomButton from '../../../../components/General/CustomButton';
import useStyles from './styles';

interface FinishEnrollmentModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

function FinishEnrollmentModal({
  open,
  onClose,
  onConfirm,
  loading = false,
}: FinishEnrollmentModalProps) {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <Card className={classes.modal}>
          <CardContent className={classes.modalContent}>
            <Box className={classes.modalTitleContainer}>
              <Box className={classes.modalTitleAndIcon}>
                <Typography variant="h4" color="primary" fontWeight="bold">
                  Alumno no interesado
                </Typography>
              </Box>
              <IconButton onClick={onClose} disabled={loading}>
                <CloseIcon color="primary" />
              </IconButton>
            </Box>
            <Box className={classes.modalDeleteBody}>
              <Typography variant="body1" textAlign="center">
                ¿Estas seguro que quieres eliminar el
                proceso de inscripción de este alumno?
              </Typography>
            </Box>
            <Box className={classes.modalButtonsContainer}>
              <CustomButton
                text="Cancelar"
                colorType="tertiary"
                onClick={onClose}
                disabled={loading}
                icon={<CloseIcon />}
              />
              <CustomButton
                text="Confirmar"
                colorType="tertiary"
                onClick={onConfirm}
                disabled={loading}
                loading={loading}
                icon={<DeleteIcon />}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
}

export default FinishEnrollmentModal;
